import { Injectable } from '@angular/core';
import { Observable, combineLatest, filter, map } from 'rxjs';
import { EmbedReportState } from '@mode/reports/sandbox/contract';
import { LegacyEmbedViewerStoreService } from '../legacy-embed-viewer-store.service';
import * as DatasetSelectors from './embed-datasets.selectors';

@Injectable({
  providedIn: 'root',
})
export class EmbedDatasetsFacade {
  private legacyEmbedDatasetsLoadedForAllLocalQueries$: Observable<boolean>;
  legacyEmbedDatasets$: Observable<
    Readonly<{
      [token: string]: Readonly<EmbedReportState.EmbedDataset>;
    }>
  >;
  legacyEmbedDatasetsForLocalQueriesOrderedByCreationDate$: Observable<Readonly<EmbedReportState.EmbedDataset>[]>;

  constructor(private store: LegacyEmbedViewerStoreService) {
    // Currently, we will only ever get these datasets for local queries
    // We need to do more work to get access to this data for imported Datasets
    // Given all the changes we've made for "glorious future", this probably just needs to be rewritten.
    this.legacyEmbedDatasetsLoadedForAllLocalQueries$ = this.store.select(
      DatasetSelectors.legacyEmbedDatasetsLoadedForAllLocalQueries
    );

    this.legacyEmbedDatasets$ = combineLatest([
      this.store.select(DatasetSelectors.legacyEmbedDatasets),
      this.legacyEmbedDatasetsLoadedForAllLocalQueries$,
    ]).pipe(
      filter(([_, loaded]) => loaded),
      map(([datasets]) => datasets)
    );

    this.legacyEmbedDatasetsForLocalQueriesOrderedByCreationDate$ = combineLatest([
      this.store.select(DatasetSelectors.legacyEmbedDatasetsForLocalQueriesOrderedByCreationDate),
      this.legacyEmbedDatasetsLoadedForAllLocalQueries$,
    ]).pipe(
      filter(([_, loaded]) => loaded),
      map(([datasets]) => datasets)
    );
  }
}
